module.exports = __webpack_public_path__ + "static/404-Image-9c0872001833504eb591009b4a562162.png";